import { NgModule } from '@angular/core';
import { ColSpanDirective } from './col-span.directive';

@NgModule({
  declarations: [ColSpanDirective],
  exports: [ColSpanDirective],
})
export class ColSpanModule {}
